import React, { type ReactNode } from 'react';
import { tv } from '@/utils/tv';

const chip = tv({
  base: 'text-caption-12 flex shrink-0 items-center gap-1 rounded-xl bg-info-surface px-2 py-0.5 text-primary',
});

interface Props {
  icon: ReactNode;
  label: string;
  className?: string;
}

export const LessonDetailsChip: React.FC<Props> = ({
  icon,
  label,
  className,
}) => (
  <span className={chip({ class: className })}>
    {icon}
    <span className="translate-y-px">{label}</span>
  </span>
);
